import React, { useMemo } from 'react';
import { Box, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import Sales from '../../components/Table/Mobile/Sales';
import { DateTimePickerCustom, CircularProgressCustom } from '../../components';
import { STATUS_SALE } from '../../helpers/enums';

const SalesView = ({ date = new Date(), salesData = [], loadingSales, saving, readonly = false, users = [], onChangeDate, onRefresh, onCompleteOrders, showCalendar = true, visualVariant = 'default', onlyTodayPending = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const isSameLocalDate = (value) => {
      if (!value) return false;
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return false;
      const today = new Date();
      return (
        parsed.getFullYear() === today.getFullYear() &&
        parsed.getMonth() === today.getMonth() &&
        parsed.getDate() === today.getDate()
      );
    };

    const filteredSalesData = useMemo(() => {
      if (!(visualVariant === 'cashier' && onlyTodayPending)) {
        return salesData;
      }

      return (salesData || []).filter((sale) => {
        if (sale?.status !== STATUS_SALE.RESERVED) return true;
        return isSameLocalDate(sale?.created_at || sale?.created_sale || sale?.updated_at);
      });
    }, [salesData, visualVariant, onlyTodayPending]);

    const handleChangeDate = async (date) => {
      onChangeDate && onChangeDate(date);
    }

    return (<Box width={!isMobile ? '30%' : null} sx={{ background: !isMobile ? '#F6EDE1' : '' }}>
      {!showCalendar && (
        <Box display='flex' justifyContent='flex-end' alignItems='center' px={1} pt={1} gap={1}>
          <Tooltip title='Actualizar ventas diarias'>
            <span>
              <IconButton
                size='small'
                onClick={() => onRefresh && onRefresh()}
                disabled={loadingSales || saving}
                sx={{
                  bgcolor: '#fcf8f2',
                  border: '1px solid #ece3d6',
                  '&:hover': { bgcolor: '#f7efe4' }
                }}
              >
                <Refresh fontSize='small' />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}

      {showCalendar && (
        <Box>
          <DateTimePickerCustom date={date} calendar onChange={handleChangeDate} />
        </Box>
      )}
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        width='100%'
        flex='1'
        padding={2}
        alignItems={!isMobile && loadingSales ? 'center' : null}
      >
        {loadingSales || saving ? <CircularProgressCustom size={150} /> :
          <Sales users={users} readonly={readonly} salesData={filteredSalesData} onCompleteSales={onCompleteOrders} tittle='Ventas' visualVariant='default' />
        }
      </Box>
    </Box>)
  }

  export default SalesView;